module.exports = __webpack_public_path__ + "img/f3-3-l.4ee47b23.png";